import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, Text, useResponsive } from '@common-fe/common-fe';

import { IOcrAccountOrderDtoAccountTypeEnum  } from '@/dtos';
import { PaymentOrder } from '@/modules/UseMyMoney/components';
import { useDocumentOcrStore } from '@/modules/UseMyMoney/stores';

interface Props extends BoxExtendedProps {
  isLoading?: boolean;
  isHsaWithdrawal?: boolean;
}

const ClaimSummaryPaymentOrder: React.FC<Props> = ({ isLoading, isHsaWithdrawal, ...props }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const { ocrDocument } = useDocumentOcrStore();

  const accountOrders = useMemo(() => {
    if (isHsaWithdrawal) {
      return ocrDocument?.availableAccounts?.filter((account) => account?.accountType === IOcrAccountOrderDtoAccountTypeEnum.HSA);
    }

    return ocrDocument?.availableAccounts;
  }, [ocrDocument?.availableAccounts, isHsaWithdrawal]);

  return (
    <Box data-testId="claim-summary-payment-order" {...props}>
      <Text data-testId="claim-summary-payment-order_description" weight={700}>
        {t('Payment order')}
      </Text>

      <PaymentOrder
        margin={{ top: 'spacing8' }}
        accountOrders={accountOrders}
        isLoading={isLoading}
        isMobile={isMobile}
      />
    </Box>
  );
};

export default ClaimSummaryPaymentOrder;
